import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PagetitleComponent } from './pagetitle/pagetitle.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [PagetitleComponent],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule
  ],
  exports: [PagetitleComponent]
})
export class UiModule { }
